"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var state_manager_1 = require("./state-manager");
var session_data_store_1 = require("../data-store/session-data-store");
var event_bus_1 = require("@idp/event-bus");
var StateProvider = /** @class */ (function () {
    function StateProvider() {
    }
    StateProvider.getStateManagerInstance = function (nSpace) {
        if (StateProvider.stateManagerInstance) {
            return StateProvider.stateManagerInstance;
        }
        state_manager_1.StateManager.setup(new session_data_store_1.SessionDataStore(), event_bus_1.ICCEventBusManager.getInstance());
        StateProvider.stateManagerInstance = state_manager_1.StateManager.buildStateProxyForNamespace(nSpace);
        return StateProvider.stateManagerInstance;
    };
    return StateProvider;
}());
exports.StateProvider = StateProvider;
//# sourceMappingURL=state-provider.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/state-manager/state-manager/state-provider.js
// module id = 1190
// module chunks = 8